<template>
  <div class="gyh-block">
    <g-switch-list1
      :chip="chip"
      v-for="(d, i) in data.horizontal"
      :key="'h' + i"
      :horizontal-type="1"
      :title="d.title"
      :columns="4"
      :list="d.list"></g-switch-list1>
  </div>

</template>

<script>
  import mixin from '../mixins';

  import GSwitchList1 from '../../c_game-switch/switch-list/g_switch-1'; // 横向


  export default {
    name: "gyh",
    mixins: [mixin],
    components: {
      GSwitchList1
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pageComponents/pk10/gyzh.vue